module.exports = __webpack_public_path__ + "static/media/globe.7da9bc9e.svg";